export default "__VITE_ASSET__BXF1RE$R__";